// extracted by mini-css-extract-plugin
export default {"wysiwyg":"WYSIWYGTextarea_wysiwyg__8wZL4"};